import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  scrollY: 0,
  isMenuOpen: false,
  opacityBurger: 0,
  isLargeScreen: window.innerWidth > 1024,
};

const headerSlice = createSlice({
  name: "header",
  initialState,
  reducers: {
    setScrollY(state, action) {
      state.scrollY = action.payload;
    },
    setIsMenuOpen(state) {
      state.isMenuOpen = !state.isMenuOpen;
    },
    setIsMenuOpenLang(state) {
      state.isMenuOpen = false;
    },
    setOpacityBurger(state, action) {
      state.opacityBurger = action.payload;
    },
    setIsLargeScreen(state, action) {
      state.isLargeScreen = action.payload;
    },
  },
});

export const { setScrollY, setIsMenuOpen, setOpacityBurger, setIsLargeScreen, setIsMenuOpenLang } = headerSlice.actions;

export default headerSlice.reducer;
